export const TABS_COUNT = 2;
export const MAIN_HORIZONTAL_SCROLL_DURATION = 0.2;
